<template>
   <div class="plan">
      <h3>Plans</h3>
      <div class="search-wrapper">
         <input-field
            type="text"
            class="search-input"
            placeholder="Search by plan name or municipility name"
            v-model="searchText"
            :errors="[]"
         />
         <router-link
            :to="{name: 'create-plan'}"
            class="create-plan"
            v-if="isPlannerOrHigher"
            >
            <add-button>Create a plan</add-button>
         </router-link>
      </div>
      <el-tabs v-model="activePane">
         <el-tab-pane label="My Plans" name="owned">
            <div v-if="ownedPlans.length">
               <plan-list-item
                  v-for="plan in ownedPlans"
                  :key="plan.id"
                  :plan="plan"
                  @delete="deletePlan"
               />
            </div>
            <div v-else style='text-align: center;'>
               No plans {{ searchText && `matching ${searchText}` }}
            </div>
         </el-tab-pane>
         <el-tab-pane label="Other Plans" name="others">
            <div v-if="otherPlans.length">
               <plan-list-item
                  v-for="plan in otherPlans"
                  :key="plan.id"
                  :plan="plan"
                  @delete="deletePlan"
               />
            </div>
            <div v-else style='text-align: center;'>
               No plans {{ searchText && `matching ${searchText}` }}
            </div>
         </el-tab-pane>
      </el-tabs>
      <div style='margin-top: 0.3em; display: flex; justify-content: flex-end;'>
         <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :page-size="15"
            :total="total">
         </el-pagination>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Pagination, Tabs,TabPane } from 'element-ui';
import InputField from '@/components/molecules/Login/InputField';
import AddButton from '@/components/molecules/Home/Plan/AddButton';
import PlanListItem from '@/components/organisms/Home/Plan/PlanListItem';
import { fetchWithAuthToken, postWithAuthToken } from '../../../../../axios';
import { showError, showSuccess } from '../../../../../js/ui-helpers';

export default {
   name: "plan",
   components: {
      'el-tabs': Tabs,
      'el-tab-pane': TabPane,
      'el-pagination': Pagination,
      InputField,
      PlanListItem,
      AddButton,
   },
   data() {
      return {
         searchText: '',
         ownedPlans: [],
         otherPlans: [],
         currentPage: 1,
         activePane: 'owned',
         totalOwned: 0,
         totalOthers: 0,
         debounce: null,
      }
   },
   computed: {
      ...mapGetters('users', ['isPlannerOrHigher']),
      total()
      {
         return this.activePane === 'owned' ? this.totalOwned : this.totalOthers;
      },
   },
   watch: {
      searchText: {
         handler: 'debounceSearch',
         immediate: true,
      },
   },
   methods: {
      debounceSearch(value)
      {
         clearTimeout(this.debounce);
         this.debounce = setTimeout(() =>
         {
            this.searchText = value;
            this.loadPlans();
         }, 500);
      },
      loadPlans()
      {
         fetchWithAuthToken(`api/plan?search=${this.searchText}&page=${this.currentPage}`)
         .then(res =>
         {
            this.ownedPlans = res.data.results;
            this.totalOwned = res.data.count;
         });

         fetchWithAuthToken(`api/plan?others=true&search=${this.searchText}&page=${this.currentPage}`)
         .then(res =>
         {
            this.otherPlans = res.data.results
            this.totalOthers = res.data.count;
         });
      },
      deletePlan(plan_id)
      {
         postWithAuthToken(`api/plan/${plan_id}`, {}, {method: 'delete'})
         .then(() => {
            this.loadPlans();
            showSuccess('Delete plan', 'Plan deleted')
         })
         .catch(() =>
         {
            showError('Delete plan', 'Failed to delete plan.');
         });
      },
      handleCurrentChange(val)
      {
         this.currentPage=val;
         this.loadPlans();
      },
   },
}
</script>

<style lang="scss">
.plan {
   border-radius: 4px;
   /* overflow: hidden; */
   min-height: 100%;
   padding: 1em;
   h3 {
      color: $font-color;
      font-family: $primary-font;
   }

   .search-wrapper {
      display: flex;
      align-items: center;
      .search-input {
         flex: 1;
      }
      .create-plan {
         svg {
            margin-right: 2px;
         }
         width: max-content;
         margin-left: 2px;
         padding: 2px;
         font-size: 0.9em;
         border-radius: 2px;
         display: flex;
         align-items: center;
         color: $font-color;
         cursor: pointer;
      }
   }

   > .el-tabs {
      height: 100%;
      font-family: $primary-font;
      .el-tabs__header .el-tabs__item {
         font-size: 0.95em;
         &.is-active {
            color: $primary-color;
         }
      }
   }
}
</style>
